import { createContext, useContext, useMemo, useRef } from 'react';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import { FloatingAlertList as FoundationsFloatingAlertList } from 'foundations-components/transitional/components/FloatingAlertList';
import { useStableFunction } from 'forms-ai-lib/internal/hooks/useStableFunction';
import { trackEvent } from 'forms-ai-lib/internal/utils/usageTracker';
import { TRACKING_EVENT_ACTIONS } from 'forms-ai-lib/internal/constants';
// Augmenting this type because the upstream doesn't specify the content
import { jsx as _jsx } from "react/jsx-runtime";
const AlertStoreContext = /*#__PURE__*/createContext(null);
export function useAlertStore() {
  const alertStore = useContext(AlertStoreContext).floatingAlertStore;
  const addAlert = useStableFunction(alert => {
    alertStore.addAlert(Object.assign({}, alert, {
      onClose: () => {
        if (alert.id) {
          trackEvent('settingsInteraction', {
            action: TRACKING_EVENT_ACTIONS.CLICKED_DISMISS_ALERT,
            values: alert.id
          });
        }
      }
    }));
  });
  const removeAlert = useStableFunction(alertId => {
    alertStore.removeAlert(alertId);
  });
  const clearAllAlerts = useStableFunction(() => {
    for (const alert of Object.values(alertStore.getAlerts())) {
      if (alert.id !== undefined) {
        alertStore.removeAlert(alert.id);
      }
    }
  });
  return {
    addAlert,
    removeAlert,
    clearAllAlerts
  };
}
export const FloatingAlertList = ({
  use
}) => {
  const alertStore = useContext(AlertStoreContext).floatingAlertStore;
  return /*#__PURE__*/_jsx(FoundationsFloatingAlertList, {
    use: use,
    alertStore: alertStore
  });
};
const AlertStoreContextProvider = ({
  children
}) => {
  const floatingAlertStore = useRef(FloatingAlertStore.newFloatingAlertStore()); // provide a stable reference to the floating alert store
  const value = useMemo(() => ({
    floatingAlertStore: floatingAlertStore.current
  }), [floatingAlertStore]);
  return /*#__PURE__*/_jsx(AlertStoreContext.Provider, {
    value: value,
    children: children
  });
};
export default AlertStoreContextProvider;